(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visibleVideos = new Set();
  const load = video => {
    if (video.dataset.bmLoaded) return;
    video.dataset.bmLoaded = 'true';
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();
  };
  const play = video => {
    if (document.hidden || reducedMotion.matches) return;
    load(video);
    video.play()?.catch(() => { video.controls = true; });
  };
  const preloadObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      load(target);
      preloadObserver.unobserve(target);
    });
  }, { rootMargin: '200px' }) : null;
  const playbackObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        visibleVideos.add(target);
        play(target);
      } else {
        visibleVideos.delete(target);
        target.pause();
      }
    });
  }, { threshold: 0.1 }) : null;
  const init = root => {
    root.querySelectorAll('video[data-bm-lazy-video]').forEach(video => {
      if (video.dataset.bmObserved) return;
      video.dataset.bmObserved = 'true';
      video.controls = reducedMotion.matches;
      if (preloadObserver) {
        preloadObserver.observe(video);
        playbackObserver.observe(video);
      } else {
        load(video);
        video.controls = true;
      }
    });
  };
  document.addEventListener('visibilitychange', () => {
    visibleVideos.forEach(video => document.hidden ? video.pause() : play(video));
  });
  reducedMotion.addEventListener('change', () => {
    document.querySelectorAll('video[data-bm-lazy-video]').forEach(video => {
      video.controls = reducedMotion.matches;
      if (reducedMotion.matches) video.pause();
    });
    if (!reducedMotion.matches) visibleVideos.forEach(play);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('video[data-bm-lazy-video]').forEach(video => {
      video.pause();
      visibleVideos.delete(video);
      preloadObserver?.unobserve(video);
      playbackObserver?.unobserve(video);
    });
  });
  init(document);
})();

(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const animations = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (preference.matches || document.hidden) return;
      const animation = target.animate([
        { transform: 'translateY(36px)', opacity: 0.08 },
        { transform: 'translateY(0)', opacity: 1 }
      ], { duration: 480, easing: 'cubic-bezier(.2,.7,.2,1)' });
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });
  const init = root => {
    root.querySelectorAll('.ingredients__header, .image-with-text__heading, .collapsible-content-header, .social-media-content__info, .social-media-header__title, .comparison__heading, .image-with-text__image-wrapper, .ingredient-card, .social-media-content__slider').forEach(element => {
      if (element.dataset.bmRevealReady) return;
      element.dataset.bmRevealReady = 'true';
      if (element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
    });
  };
  preference.addEventListener('change', () => {
    if (preference.matches) animations.forEach(animation => animation.cancel());
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bm-reveal-ready]').forEach(element => observer.unobserve(element));
  });
  init(document);
})();
